
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getNotInDeptUserList, getDeptUserList, batchDelDeptUser } from '@/api/company';
import { timeoutUserLists, timeoutUser } from '@/api/system';
import { setUserDept, setUserRole, getRoleUserList, getNoRoleUserList, batchDelRoleUser, authUserList } from '@/api/users';
import { UserModule } from '../../store/modules/user';
@Component({
  name: 'SetStaff',
  components: {}
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  dialogSetStaffVisible!: Boolean;
  @Prop({
    type: String,
    default: ''
  })
  paramsStr!: String;
  @Prop({
    type: Number,
    default: 0
  })
  typeEnter!: Number;
   private title='';
  // 1 添加部门人员 2 删除部门人员 3 添加角色人员 4 删除角色人员  5 提醒人员设定
  private listQuery:{
    name: string,
  } = {
    name: ''
  };
  private selectedDynamicTags:any=[]
  private customHeight = window.innerHeight * 0.4;
  created() {
    this.getList();
  }
  // 列表
  private tableList = [];
  private page = 1;
  private loadMore=false;

  cancleDialogHandle() {
    this.$emit('close', false);
  }
  finishDialogHandle() {
    this.conform();
  }
  // 搜索
  private search() {
    this.getList();
  }
  // 搜索清楚
  private restSearch() {
    this.listQuery = {
      name: ''
    };
    this.getList();
  }
  // 加载更多
  private moreData() {
    this.page = this.page + 1;
    this.getList();
  }
  // 获取列表
  private getList() {
    // 人员不再部门内
    switch (this.typeEnter) {
      case 1:
        this.title = '添加人员';
        this.getNotInDeptUserList();
        break;
      case 2:
        this.title = '删除人员';
        this.getDeptUserList();
        break;
      case 3:
        this.title = '添加人员';
        this.getNoRoleUserList();
        break;
      case 4:
        this.title = '删除人员';
        this.getRoleUserList();
        break;
      case 5:
        this.title = '提醒人员设定';
        this.authUserList();
        break;
    }
  }
  // 确认 按钮
  private conform() {
    if (this.selectedDynamicTags.length < 1) {
      return;
    }
    switch (this.typeEnter) {
      case 1:
        this.setDeptUserList(this.selectedDynamicTags);
        break;
      case 2:
        this.delDeptUserList(this.selectedDynamicTags);
        break;
      case 3:
        this.setRoleUserList(this.selectedDynamicTags);
        break;
      case 4:
        this.delRoleUserList(this.selectedDynamicTags);
        break;
      case 5:
        this.remainUserList(this.selectedDynamicTags);
        // 提醒人员设定
        break;
    }
  }
  // 添加 部门人员列表
  private getNotInDeptUserList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    params.dept_id = this.paramsStr;
    params.page = this.page;
    params.name = this.listQuery.name;
    getNotInDeptUserList(params)
      .then(res => {
        if (res.data) {
          if (this.page === 1) {
            this.tableList = res.data.list;
          } else {
            this.tableList = this.tableList.concat(res.data.list);
          }
          if ((res as any).data && (res as any).data.page_count > (res as any).data.page_current) {
            this.loadMore = true;
          } else {
            this.loadMore = false;
          }
        } else {
          this.tableList = [];
        }
      })
      .catch(err => {
        this.tableList = [];
        let msg = err.msg;
      });
  }
  // 添加 部门人员
  private setDeptUserList(departmentData:any) {
    let _this = this;
    var userStr = '';
    for (var user of departmentData) {
      userStr += (user as any).id + ',';
    }
    userStr = userStr.substr(0, userStr.length - 1);
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      department_str: this.paramsStr,
      user_str: userStr
    };
    setUserDept(params)
      .then(res => {
        _this.page = 1;
        _this.$emit('close', false);
        _this.$notify({
          title: '提示',
          message: (res as any).msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'success'
        });
      })
      .catch(err => {
        _this.$notify({
          title: '提示',
          message: err.msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'error'
        });
      });
  }
  // 删除 部门人员
  private delDeptUserList(departmentData:any) {
    let _this = this;
    var userStr = '';
    for (var user of departmentData) {
      userStr += (user as any).id + ',';
    }
    userStr = userStr.substr(0, userStr.length - 1);
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      dept_id: this.paramsStr,
      user_str: userStr
    };
    batchDelDeptUser(params)
      .then(res => {
        _this.page = 1;
        _this.$emit('close', false);
        _this.$notify({
          title: '提示',
          message: (res as any).msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'success'
        });
      })
      .catch(err => {
        _this.$notify({
          title: '提示',
          message: err.msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'error'
        });
      });
  }
  // 删除 部门人员 列表
  private getDeptUserList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    params.dept_id = this.paramsStr;
    params.page = this.page;
    params.name = this.listQuery.name;
    getDeptUserList(params)
      .then(res => {
        if (res.data) {
          if (this.page === 1) {
            this.tableList = res.data.list;
          } else {
            this.tableList = this.tableList.concat(res.data.list);
          }
          if ((res as any).data && (res as any).data.page_count > (res as any).data.page_current) {
            this.loadMore = true;
          } else {
            this.loadMore = false;
          }
        } else {
          this.tableList = [];
        }
      })
      .catch(err => {
        this.tableList = [];
        let msg = err.msg;
      });
  }
  // 删除 角色人员列表
  private getRoleUserList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    params.company_role_id = this.paramsStr;
    params.name = this.listQuery.name;
    params.page = this.page;
    getRoleUserList(params)
      .then(res => {
        if (res.data) {
          if (this.page === 1) {
            this.tableList = res.data.list;
          } else {
            this.tableList = this.tableList.concat(res.data.list);
          }
          if ((res as any).data && (res as any).data.page_count > (res as any).data.page_current) {
            this.loadMore = true;
          } else {
            this.loadMore = false;
          }
        } else {
          this.tableList = [];
        }
      })
      .catch(err => {
        this.tableList = [];
        let msg = err.msg;
      });
  }

  // 设置超时提醒人员列表
  private authUserList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    params.role_type = 1;
    params.name = this.listQuery.name;
    params.page = this.page;
    authUserList(params)
      .then(res => {
        if (res.data) {
          if (this.page === 1) {
            this.tableList = res.data.list;
          } else {
            this.tableList = this.tableList.concat(res.data.list);
          }
          if ((res as any).data && (res as any).data.page_count > (res as any).data.page_current) {
            this.loadMore = true;
          } else {
            this.loadMore = false;
          }
        } else {
          this.tableList = [];
        }
        this.getSelectauthUserList();
      })
      .catch(err => {
        this.tableList = [];
        let msg = err.msg;
      });
  }

  // 设置超时提醒人员列表
  private getSelectauthUserList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    timeoutUserLists(params)
      .then(res => {
        if (res.data) {
          var tempList:any = [];
          res.data.list.map((temp: any) => {
            this.tableList.map((t:any) => {
              if (t.id === temp.user_id) {
                tempList.push(t);
              }
            });
          });
          this.selectedDynamicTags = tempList;
          // this.selectedDynamicTags.map((temp : any) => {
          // });
          this.toggleSelection(this.selectedDynamicTags);
        } else {
        //   this.tableList = [];
        }
      })
      .catch(err => {
        let msg = err.msg;
      });
  }

  // 添加 部门人员列表
  private getNoRoleUserList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    params.company_role_id = this.paramsStr;
    params.page = this.page;
    params.name = this.listQuery.name;
    getNoRoleUserList(params)
      .then(res => {
        if (res.data) {
          if (this.page === 1) {
            this.tableList = res.data.list;
          } else {
            this.tableList = this.tableList.concat(res.data.list);
          }
          if ((res as any).data && (res as any).data.page_count > (res as any).data.page_current) {
            this.loadMore = true;
          } else {
            this.loadMore = false;
          }
        } else {
          this.tableList = [];
        }
      })
      .catch(err => {
        this.tableList = [];
        let msg = err.msg;
      });
  }
  // 添加 角色人员
  private setRoleUserList(roleData:any) {
    let _this = this;
    var userStr = '';
    for (var user of roleData) {
      userStr += (user as any).id + ',';
    }
    userStr = userStr.substr(0, userStr.length - 1);
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      company_role_id: this.paramsStr,
      user_str: userStr,
      vip_level: (UserModule.company as any).vip_level
    };
    setUserRole(params)
      .then(res => {
        _this.page = 1;
        _this.$emit('close', false);
        _this.$notify({
          title: '提示',
          message: (res as any).msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'success'
        });
      })
      .catch(err => {
        _this.$notify({
          title: '提示',
          message: err.msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'error'
        });
      });
  }
  // 删除 角色人员
  private delRoleUserList(departmentData:any) {
    let _this = this;
    var userStr = '';
    for (var user of departmentData) {
      userStr += (user as any).uid + ',';
    }
    userStr = userStr.substr(0, userStr.length - 1);
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      company_role_id: this.paramsStr,
      user_str: userStr
    };
    batchDelRoleUser(params)
      .then(res => {
        _this.page = 1;
        _this.$emit('close', false);
        _this.$notify({
          title: '提示',
          message: (res as any).msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'success'
        });
      })
      .catch(err => {
        _this.$notify({
          title: '提示',
          message: err.msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'error'
        });
      });
  }

  private remainUserList(val:any) {
    let _this = this;
    var t :any = [];
    val.map((temp:any) => {
      var b:any = {};
      b.user_id = temp.id;
      b.user_name = temp.name;
      t.push(b);
    });
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_name: UserModule.getUserName,
      timeout_user: JSON.stringify(t)
    };
    timeoutUser(params)
      .then(res => {
        _this.$emit('close', false);
        _this.$notify({
          title: '提示',
          message: (res as any).msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'success'
        });
      })
      .catch(err => {
        _this.$notify({
          title: '提示',
          message: err.msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'error'
        });
      });
  }

  private handleSelectionChange(val: []) {
    this.selectedDynamicTags = val;
  }
  private closeTagHandle(val: any) {
    let _this = this;
    _this.selectedDynamicTags.splice(_this.selectedDynamicTags.indexOf(val), 1);
    for (let index = 0; index < _this.tableList.length; index++) {
      if ((_this.tableList[index] as any).id === (val as any).id) {
        _this.toggleSelection([_this.tableList[index]]);
      }
    }
  }
  private toggleSelection(rows: any) {
    if (rows) {
      rows.forEach((row: any) => {
        (this.$refs.tableAll as any).toggleRowSelection(row);
      });
    } else {
      (this.$refs.tableAll as any).clearSelection();
    }
  }
  close() {
    this.page = 1;
    this.$emit('close', false);
  }
}
